import React, {Fragment} from "react";
import {withRouter} from "react-router-dom";
// import ModalContentBuyOrSubscribe from "../componentsBange/ModalContentBuyOrSubscribe/ModalContentBuyOrSubscribe"; // Nicht mehr ben�tigt
import ModalContentLogin from "../componentsBange/ModalContentLogin/ModalContentLogin";
import ModalContentRegister from "../componentsBange/ModalContentRegister/ModalContentRegister";
import ModalContentRegisterSuccess from "../componentsBange/ModalContentRegisterSuccess/modalContentRegisterSuccess";
import ModalContentCoupon from "../componentsBange/ModalContentCoupon/ModalContentCoupon";
import {loginUser} from "../reducers/authentication/actions";
import Close from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import './viewer.css';
import {fetchBookByAuthorAndTitle, fetchChapterById} from '../reducers/content/actions';
import {orderBook} from '../reducers/order/actions';
import {connect} from 'react-redux';
// import ModalContentBuyCheckout from "../componentsBange/ModalContentBuyCheckout/ModalContentBuyCheckout"; // Nicht mehr ben�tigt
// import ModalContentAboCheckout from "../componentsBange/ModalContentAboCheckout/ModalContentAboCheckout"; // Nicht mehr ben�tigt
// import CheckoutPurchase from "./CheckoutPurchase"; // Nicht mehr ben�tigt
// import CheckoutSubscription from "./CheckoutSubscription"; // Nicht mehr ben�tigt
import {getUserActiveSubscription} from "../reducers/user/actions";
import {isMobile} from "../utils/device";
import {getProduct} from "../reducers/products/actions";
import Modal from 'react-bootstrap/Modal';

class ViewerModal extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      // buyAccess wurde entfernt
      modalState: "",
      modalAction: "coupon", // Aktion auf Coupon festlegen
      email: "",
      password: "",
      loginError: false,
      loginLoading: false,
      loading: true
    }
  }

  componentDidMount() {
    // Geoposition-Logik wurde entfernt.

    // Produkte werden geladen, falls f�r die Coupons oder die Preisanzeige ben�tigt
    this.props.getProduct("SINGLE_BOOK");
    this.props.getProduct("FLATRATE");

    // Initialen Modal-Status setzen
    if (this.props.authenticated) {
      // Wenn eingeloggt, direkt zum Coupon-Einl�sen
      this.setState({modalState: "completeCoupon", loading: false});
    } else {
      // Ansonsten zum Login leiten
      this.setState({modalState: "login", loading: false});
    }
  }


  componentDidUpdate(prevProps) {
    // Reduziert auf die �berwachung der Authentifizierung (z.B. nach erfolgreicher Registrierung)
    if (prevProps.authenticated !== this.props.authenticated && this.props.authenticated) {
      // Nach erfolgreichem Login/Registrierung sofort zum Coupon-Formular
      this.setState({modalState: "completeCoupon"});
    }
  }

  onLogin = (email, password) => {
    this.setState({loginLoading: true});
    if (email.length > 0 && password.length > 0) {
      this.props.login(email, password, () => {
        // success: Leite immer zum Coupon-Einl�sen weiter, da modalAction="coupon"
        this.setState({modalState: "completeCoupon", loginError: false, loginLoading: false});
      }, () => {
        // fail to login
        this.setState({modalState: "login", loginError: true, loginLoading: false});
        console.log(this.state.loginError, "loginerror");
      })
    }
    this.setState({loginLoading: false});
  };

  onContinue = () => {
    // Nach erfolgreicher Registrierung (Success-State) immer zum Coupon-Einl�sen weiterleiten
    this.setState({modalState: "completeCoupon", loginError: false, loginLoading: false});
  }

  renderMobile() {
    // Die Modal-Wrapper-Logik bleibt erhalten
    return (<Fragment>

      {this.props.open && this.props.noSubError && <div style={{
        position: "fixed",
        top: 0,
        height: "100%",
        width: "100%",
        zIndex: 1035,
        background: "white",
        boxShadow: "0 0 3px 3px rgba(0, 0,0,.1)",
        margin: "auto",
        overflow: "scroll"
      }}>

        <div className="py-3" style={{position: "relative", width: "100%", height: "100%"}}>

          <div className={'modal-header'}>
            {/* Titel ist nun fest auf Coupon-Einl�sen */}
            <Fragment>Jetzt E-Book-Code einl&ouml;sen</Fragment>

            <IconButton style={{position: "absolute", top: 8, right: 2}} className="modal-close-button"
                        onClick={() => {
                          this.props.handleClose();
                          // Setze modalState zur�ck
                          this.setState({modalState: "login"})
                        }}>
              <Close style={{color: "#005CA8", width: 35, height: 35}}/>
            </IconButton>
          </div>

          {!this.state.loading?
            <Fragment>
              {/* Login-Flow */}
              {this.state.modalState === "login" && !this.props.authenticated &&
                <ModalContentLogin loading={this.state.loginLoading} error={this.state.loginError}
                                   onLogin={this.onLogin}
                                   onClickRegister={() => this.setState({modalState: "register"})}/>}

              {this.state.modalState === "register" && !this.props.authenticated &&
                <ModalContentRegister onRegisterSuccess={() => {
                  this.setState({modalState: "registerSuccess"})
                }}/>}

              {this.state.modalState === "registerSuccess" && this.props.authenticated &&
                <ModalContentRegisterSuccess action={this.state.modalAction} // action ist "coupon"
                                             onContinue={this.onContinue.bind(this)}/>}

              {/* Coupon-Checkout: Wird gerendert, wenn der Zustand "completeCoupon" ist und der Benutzer authentifiziert ist. */}
              {this.state.modalState === "completeCoupon" && this.props.authenticated &&
                <ModalContentCoupon isbn={this.props.currentBook.isbn}
                                    onBack={() => this.setState({modalState: "login"})}/>
              }
            </Fragment>
            :null}
        </div>
      </div>}
    </Fragment>)
  }

  render() {
    if (isMobile) {
      return this.renderMobile();
    }
    return (
      <Modal show={this.props.open && this.props.noSubError} size="lg">

        <Modal.Header closeButton={false}>
          <Modal.Title id="contained-modal-title-vcenter" style={{width: "100%", textAlign: "left"}}>
            {/* Titel ist fest auf Coupon-Einl�sen */}
            <Fragment>Jetzt E-Book-Code einl&ouml;sen</Fragment>

            <button  className="MuiButtonBase-root MuiIconButton-root modal-close-button modal-close-right"
                     type="button"
                     onClick={() => {
                       this.props.handleClose();
                       this.setState({modalState: "login"}) // Zur�cksetzen des Zustands
                     }}>
                                    <span className="MuiIconButton-label">
                                        <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"
                                             role="presentation"
                                             style={{color: 'rgb(0, 92, 168)', width: 28, height: 28}}>
                                            <path
                                              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                                        </svg>
                                    </span>
              <span className="MuiTouchRipple-root">
                                    </span>
            </button>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {!this.state.loading?
            <Fragment>
              {/* Login-Flow */}
              {this.state.modalState === "login" && !this.props.authenticated &&
                <ModalContentLogin loading={this.state.loginLoading}
                                   error={this.state.loginError}
                                   onLogin={this.onLogin}
                                   onClickRegister={() => this.setState({modalState: "register"})}
                />}

              {this.state.modalState === "register" && !this.props.authenticated &&
                <ModalContentRegister onRegisterSuccess={() => {
                  this.setState({modalState: "registerSuccess"})
                }}
                />}

              {this.state.modalState === "registerSuccess" && this.props.authenticated &&
                <ModalContentRegisterSuccess onContinue={this.onContinue.bind(this)}
                />}

              {/* Coupon-Checkout: Wird gerendert, wenn der Zustand "completeCoupon" ist und der Benutzer authentifiziert ist. */}
              {this.state.modalState === "completeCoupon" && this.props.authenticated &&
                <ModalContentCoupon isbn={this.props.currentBook.isbn}
                                    onBack={() => this.setState({modalState: "login"})}
                />
              }
            </Fragment>
            :null}

        </Modal.Body>

      </Modal>)
  }
}

ViewerModal.propTypes = {};

ViewerModal.defaultProps = {};

const mapStateToProps = state => ({
  currentBook: state.content.currentBook,
  authenticated: state.authentication.authenticated,
  flatrate: state.products.flatrate,
  singleBook: state.products.singleBook
});

const mapDispatchToProps = dispatch => ({
  fetchBookByAuthorAndTitle: (author, title, successCb, errorCb) => dispatch(fetchBookByAuthorAndTitle(author, title, successCb, errorCb)),
  fetchChapterById: (chapterId, successCb, errorCb) => dispatch(fetchChapterById(chapterId, successCb, errorCb)),
  orderBook: (bookid, successCb, errorCb) => dispatch(orderBook(bookid, successCb, errorCb)),
  login: (email, password, successCb, errorCb) => dispatch(loginUser(email, password, successCb, errorCb)),
  getUserActiveSubscription: (searchterm, successCb, errorCb) => dispatch(getUserActiveSubscription(searchterm, successCb, errorCb)),
  getProduct: (code, successCb, errorCb) => dispatch(getProduct(code, successCb, errorCb))
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewerModal));
